@if (!(loading$ | async)) {
  <div class="content-layout">
    <div class="tree-wrapper">
      @for (item of viewModels$ | async; track item.id) {
        <div class="tree-row">
          @for (layout of item.layout; track layout) {
            <div [ngClass]="layout" class="layout" [style.minWidth.px]="gridSize"></div>
          }
          @let selectedExtraction = selectedExtraction$ | async;
          <semeris-dependency-tree-item
            [item]="item"
            [class.datapoint-value-changed]="selectedExtraction && selectedExtraction === item.hash"
            (editMetadata)="onEditMetadata($event)"
            (changeActive)="onChangeActive($event)"></semeris-dependency-tree-item>
        </div>
      }
    </div>
    <div class="extraction-history-wrapper" *permissions="[Permission.WRITE_DEPENDENCY_TREE]">
      <h2>Extraction History</h2>
      <semeris-ng-select
        [options]="transactions$ | async"
        placeholder="Transaction"
        bindLabel="transactionId"
        bindValue="transactionId"
        [clearable]="true"
        (valueChanged)="onLibraryTransactionChange($event)"></semeris-ng-select>
      <semeris-ng-select
        [options]="dependencyGraphs$ | async"
        placeholder="Extraction Run"
        [clearable]="true"
        (valueChanged)="onDependencyGraphChange($event)"></semeris-ng-select>
      <div class="extraction-history">
        @if (noExtractions$ | async) {
          <div class="placeholder">No extraction history</div>
        }
        <mat-selection-list
          [multiple]="false"
          (selectionChange)="onExtractionHistoryChange($event)">
          @for (item of extractions$ | async; track item.displayName) {
            <mat-list-option [value]="item">
              <div class="extraction-history-item">
                <p>{{ item.displayName }}</p>
                <p class="date">{{ item.displayDate }} - {{ item.status }}</p>
              </div>
            </mat-list-option>
          }
        </mat-selection-list>
      </div>
    </div>
  </div>
  <div class="close-btn-row">
    <div class="close-btn-row-left"></div>
    <button class="close-btn" semerisButton variant="text" [mat-dialog-close]="false">Close</button>
  </div>
} @else {
  <semeris-loader [loading]="true" [inline]="true"></semeris-loader>
}
